var e="#373a3c",n=Object.freeze({Angry:"\u{1F620}",Confused:"\u{1F615}",Sad:"\u{1F625}",Smile:"\u{1F600}",Wink:"\u{1F609}"});

export { e as a, n as b };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-EUN6EJOR.js.map